import styled from "styled-components";

const StyledArticlesBasicInfiniteCtn = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  text-align: center;
  max-width: 1440px;
  padding-right: 30px;
  padding-left: 30px;
  margin: 0 auto 0 auto;
`;

const StyledMobileArticlesBasicInfiniteCtn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: center;
  text-align: center;
  margin: 0 auto 0 auto;
`;

const StyledEndMessage = styled.div`
  display: flex !important;
  justify-content: center;
  margin: 100px auto 0 auto;
  width: 100%;
  font-size: 28px;
  line-height: 30px;
  letter-spacing: 0.28px;
  font-family: "Ogg-Regular";
`;

const StyledGridLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: center;
`;

const StyledGridColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
`;

const StyledGridRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledInfiniteScroll = styled.div`
  display: grid;
  overflow-y: hidden !important; // Need to make sure overflow hidden doesn't break infinite scroll
  grid-template-columns: repeat(3, minmax(100px, 1fr));
  grid-auto-rows: auto;
  grid-column-gap: 60px;
  grid-row-gap: 40px;
`;

const StyledInfiniteScrollTablet = styled.div`
  display: grid;
  overflow-y: hidden !important; // Need to make sure overflow hidden doesn't break infinite scroll
  grid-template-columns: repeat(2, minmax(100px, 1fr));
  grid-auto-rows: auto;
  grid-column-gap: 20px;
  grid-row-gap: 16px;
`;

const StyledInfiniteScrollMobile = styled.div`
  display: grid;
  overflow-y: hidden !important; // Need to make sure overflow hidden doesn't break infinite scroll
  grid-template-columns: repeat(1, minmax(100px, 1fr));
  grid-auto-rows: auto;
  grid-row-gap: 16px;
`;

const StyledGridRowTablet = styled.div`
  display: flex;
  flex-direction: row;
`;

export {
  StyledGridLayout,
  StyledGridColumn,
  StyledGridRow,
  StyledGridRowTablet,
  StyledInfiniteScroll,
  StyledInfiniteScrollTablet,
  StyledInfiniteScrollMobile,
  StyledEndMessage,
  StyledArticlesBasicInfiniteCtn,
  StyledMobileArticlesBasicInfiniteCtn,
};
